import React, {Component} from 'react';
import {
  Layout,
  Card,
  SkeletonBodyText,
  DataTable,
  Button,
  TextField,
  ButtonGroup
} from '@shopify/polaris';
import {
  ArrowLeftMinor,
  ArrowRightMinor
} from '@shopify/polaris-icons';

import Container from 'components/Container';
import {getCodes} from 'api/user';

const styles = {
  iframe: {
    border: 'none',
    width: '100%',
    height: 1000
  }
}
class Codes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      codes: null,
      page: 0,
      input: '',
      search: '',
    };
  }

  componentDidMount() {
    getCodes(this.props.status, this.state.page, this.state.search).then(codes => {
      this.setState({codes});
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.page !== this.state.page || prevState.search !== this.state.search) {
      this.setState({codes: null})
      getCodes(this.props.status, this.state.page, this.state.search).then(codes => {
        this.setState({codes});
      });
    }
  }

  onClickSearch = () => {
    if (!this.state.input) {
      alert("Please input search string");
    }
    this.setState({
      search: this.state.input,
      page: 0,
    })
  }

  reset = () => {
    this.setState({
      search: '',
      input: '',
      page: 0,
    });
  }

  render() {
    const { codes } = this.state;
    return (
      <Container pageProps={{
        title: 'Codes',
        subtitle: `Showing codes with status ${this.props.status}`,
        fullWidth: true,
        primaryAction: (
          <div style={{display: 'flex', gap: 12}}>
            <div style={{display: 'flex'}}>
              <TextField clearButton onClearButtonClick={this.reset} placeholder="Search codes..." onChange={input => this.setState({input})} value={this.state.input} />
              <Button onClick={this.onClickSearch}>Search</Button>
            </div>
            <ButtonGroup>
              <Button disabled={!this.state.page} onClick={() => this.setState({page: this.state.page - 1})} icon={ArrowLeftMinor} />
              <Button disabled={!codes || codes.length < 100} onClick={() => this.setState({page: this.state.page + 1})} icon={ArrowRightMinor} />
            </ButtonGroup>
          </div>
        )
      }}>
        <React.Fragment>
          <Layout.Section>
            <Card sectioned>
              Showing page {this.state.page + 1}
              {
                codes ? (
                  <DataTable
                    columnContentTypes={[
                      'text',
                      'text',
                      'text',
                      'text',
                      'text',
                    ]}
                    headings={[
                      'Code',
                      'Type',
                      'Value',
                      'Status',
                      'Used At',
                    ]}
                    rows={codes.map(code => ([
                      code.id,
                      code.type,
                      code.value,
                      code.status,
                      code.usedAt ? new Date(code.usedAt._seconds*1000).toDateString() : '',
                    ]))}
                  />
                ) : <SkeletonBodyText />
              }
            </Card>
          </Layout.Section>

        </React.Fragment>
      </Container>
    );
  }
}
export default Codes;
